export enum ClinicalCaseStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  UNASSIGNED = 'UNASSIGNED',
}
